<script context="module" lang="ts">
  export var id = 0;
  export const getId = (name: string) => {
    id += 1;
    return `${name} ${id}`;
  };

  export const defaultSettings = {
    text: "This is a subtitle",
    style: "",
  };
</script>

<script lang="ts">
  import ComponentContainer from "../ComponentContainer/ComponentContainer.svelte";
  import type {
    TComponentContainerSettings,
    TTag,
  } from "../ComponentContainer/types";
  import type { TSubtitleProps, TSubtitleSettings } from "./types";

  interface $$Props extends TSubtitleProps {}

  // Variables
  export let id: string;
  export let tag: TTag = "Subtitle";
  export var settings: Partial<TSubtitleSettings> = {};
  export let container: Partial<TComponentContainerSettings> = {};

  // Default Container Options
  var containerSettings = {
    ...container,
  };

  let _settings = {
    ...defaultSettings,
    ...settings,
  };
</script>

<ComponentContainer settings={containerSettings} {tag} {id}>
  <p style={_settings.style}>{_settings.text}</p>
</ComponentContainer>

<style>
  p {
    opacity: 0.6;
    font-size: 1.1rem;
  }
</style>
